export function test() {
	return null;
}

export function getOS() {
	const { userAgent } = window.navigator;
	const { platform } = window.navigator;
	const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
	const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
	const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
	let os = null;

	if (macosPlatforms.indexOf(platform) !== -1) {
		os = 'MacOS';
	} else if (iosPlatforms.indexOf(platform) !== -1) {
		os = 'iOS';
	} else if (windowsPlatforms.indexOf(platform) !== -1) {
		os = 'Windows';
	} else if (/Android/.test(userAgent)) {
		os = 'Android';
	} else if (!os && /Linux/.test(platform)) {
		os = 'Linux';
	}

	// @ts-ignore
	document.documentElement.setAttribute('os', os);
	return os;
}

export const hasNotch = () => {
	/**
	 * For storybook test
	 */
	const storybook = window.location !== window.parent.location;
	// @ts-ignore
	const iPhone = /iPhone/.test(navigator.userAgent) && !window.MSStream;
	const aspect = window.screen.width / window.screen.height;
	const aspectFrame = window.innerWidth / window.innerHeight;
	return (
		(iPhone && aspect.toFixed(3) === '0.462') ||
		(storybook && aspectFrame.toFixed(3) === '0.462')
	);
};

export const mergeRefs = (refs: any[]) => {
	return (value: any) => {
		refs.forEach((ref) => {
			if (typeof ref === 'function') {
				ref(value);
			} else if (ref != null) {
				ref.current = value;
			}
		});
	};
};

export const randomColor = () => {
	const colors = ['primary', 'secondary', 'success', 'info', 'warning', 'danger'];

	const color = Math.floor(Math.random() * colors.length);

	return colors[color];
};

export const priceFormat = (price: number) => {
    if (typeof price !== 'number') {
        return '0'; // Tampilkan pesan error atau nilai default
      }
	return price.toLocaleString('en-ID', {
		style: 'currency',
		currency: 'IDR',
        minimumFractionDigits: 0, // Menghilangkan angka desimal
        maximumFractionDigits: 0, // Menghilangkan angka desimal
	});
};
export const numberToWords = (num: number) => {
    const satuan = [
        "", "satu", "dua", "tiga", "empat", "lima",
        "enam", "tujuh", "delapan", "sembilan"
      ];
    
      const belasan = [
        "sepuluh", "sebelas", "dua belas", "tiga belas",
        "empat belas", "lima belas", "enam belas", 
        "tujuh belas", "delapan belas", "sembilan belas"
      ];
    
      const puluhan = [
        "", "", "dua puluh", "tiga puluh", "empat puluh",
        "lima puluh", "enam puluh", "tujuh puluh", 
        "delapan puluh", "sembilan puluh"
      ];
    
      const ribuan = ["", "ribu", "juta", "miliar", "triliun"];
    
      if (num === 0) return "nol";
    
      let result = "";
      let level = 0;
    
      while (num > 0) {
        const group = num % 1000;
    
        if (group > 0) {
          const groupWords = groupToWords(group);
          result = `${groupWords} ${ribuan[level]} ${result}`.trim();
        }
    
        num = Math.floor(num / 1000);
        level += 1;
      }
    
      return result.trim();
    
      function groupToWords(group: number): string {
        let words = "";
    
        const ratusan = Math.floor(group / 100);
        const sisaPuluhan = group % 100;
        const sisaSatuan = group % 10;
    
        if (ratusan > 0) {
          words += ratusan === 1 ? "seratus" : `${satuan[ratusan]} ratus`;
        }
    
        if (sisaPuluhan > 0) {
          if (sisaPuluhan < 10) {
            words += ` ${satuan[sisaPuluhan]}`;
          } else if (sisaPuluhan < 20) {
            words += ` ${belasan[sisaPuluhan - 10]}`;
          } else {
            words += ` ${puluhan[Math.floor(sisaPuluhan / 10)]}`;
            if (sisaSatuan > 0) {
              words += ` ${satuan[sisaSatuan]}`;
            }
          }
        }
    
        return words.trim();
      }
};

export const average = (array: any[]) => array.reduce((a, b) => a + b) / array.length;

export const percent = (value1: number, value2: number) =>
	Number(((value1 / value2 - 1) * 100).toFixed(2));

export const percent2 = (value1: number, value2: number) =>
	Number(((value1 / value2) * 100).toFixed(2));

export const getFirstLetter = (text: string, letterCount = 2): string =>
	// @ts-ignore
	text
		.toUpperCase()
		.match(/\b(\w)/g)
		.join('')
		.substring(0, letterCount);

export const debounce = (func: (arg0: any) => void, wait = 1000) => {
	let timeout: string | number | NodeJS.Timeout | undefined;

	return function executedFunction(...args: any[]) {
		const later = () => {
			clearTimeout(timeout);
			// @ts-ignore
			func(...args);
		};

		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
	};
};
